import { browserVersion, isSafari } from 'react-device-detect';
import { StyleSheetManager } from 'styled-components';

const MIN_SAFARI_NO_PREFIXES = 16;

export const AutoPrefixProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const enableVendorPrefixes = isSafari && Number(browserVersion) < MIN_SAFARI_NO_PREFIXES;
  // TODO - remove later, added for tracing purposes
  return <StyleSheetManager enableVendorPrefixes={enableVendorPrefixes}>{children}</StyleSheetManager>;
};
